<template>
    <div class="not-found">
      <meta http-equiv="refresh" content="5;URL=/">
      <img
          src="@/assets/404.svg" style="height: 380px"
          alt=""
      />
      <div style="text-align: center ;">
            <h2 style=" font-size: 14px;">{{$t('error.404.5m4zteaosnw2')}}</h2>
      </div>
      <div style="text-align: center; padding-top: 20px;">
            <h3>{{$t('error.404.5oor6vo8d040')}}<span>&nbsp;{{initTime}}&nbsp;</span>{{$t('error.404.5oor6vo8e700')}}</h3>
      </div>
      <img
          src="@/assets/button.svg" style="height:40px ;padding-bottom: 220px;padding-top: 40px;cursor: pointer;"
          alt=""
          @click="toRoute('/')"

      />

    </div>
</template>
<script>
export default {
  name: "NotFound",
  data() {
    return {
      initTime: 5
    }
  },
  methods: {
    leftTime() {
      this.initTime--
    },
    toRoute(path) {
      this.$router.push({
        path: path
      })
    }
  },
  created() {
    setInterval(this.leftTime, 1000)
  }
}


</script>

<style scoped>
.not-found {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
h1 {
  margin-top: 100px;
}
span {
  color: dodgerblue;
}
</style>